module.exports = require('./helpers/bundle-url').getBundleURL('01ogN') + "slack-logo.5d730c10.svg";